/**
 * Collection grid: when each visual row enters the viewport, reveal all cards in that row together.
 * Listens for facet filter AJAX refresh (facetFilters:productGridUpdated).
 */
(function () {
  const GRID_SEL = 'ul#product-grid.de-collection-row-reveal';
  const VISIBLE = 'de-collection-row-reveal--visible';
  const ROW_TOLERANCE = 2;

  function getRowGroups(grid) {
    const items = Array.from(grid.querySelectorAll(':scope > .grid__item'));
    if (!items.length) return [];

    const rows = [];
    let currentTop = null;
    let currentRow = [];

    items.forEach((el) => {
      const top = el.offsetTop;
      if (currentTop === null || Math.abs(top - currentTop) <= ROW_TOLERANCE) {
        currentRow.push(el);
        if (currentTop === null) currentTop = top;
      } else {
        rows.push(currentRow);
        currentRow = [el];
        currentTop = top;
      }
    });
    if (currentRow.length) rows.push(currentRow);
    return rows;
  }

  function revealAll(grid) {
    grid.querySelectorAll(':scope > .grid__item').forEach((li) => {
      li.classList.add(VISIBLE);
    });
  }

  function init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const grid = document.querySelector(GRID_SEL);
    if (!grid) return;

    if (grid._deRowRevealObserver) {
      grid._deRowRevealObserver.disconnect();
      grid._deRowRevealObserver = null;
    }

    grid.querySelectorAll(':scope > .grid__item').forEach((li) => {
      li.classList.remove(VISIBLE);
    });

    const rows = getRowGroups(grid);
    if (!rows.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const rowItems = entry.target._deRowRevealRow;
          if (rowItems && Array.isArray(rowItems)) {
            rowItems.forEach((li) => li.classList.add(VISIBLE));
          }
          observer.unobserve(entry.target);
        });
      },
      {
        rootMargin: '0px 0px -10% 0px',
        threshold: 0.05,
      }
    );

    rows.forEach((rowItems) => {
      const lead = rowItems[0];
      lead._deRowRevealRow = rowItems;
      observer.observe(lead);
    });

    grid._deRowRevealObserver = observer;
  }

  function onReady() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const grid = document.querySelector(GRID_SEL);
      if (grid) revealAll(grid);
      return;
    }
    init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('facetFilters:productGridUpdated', () => {
    requestAnimationFrame(() => {
      requestAnimationFrame(onReady);
    });
  });

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(onReady, 150);
  });

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target && event.target.querySelector && event.target.querySelector(GRID_SEL)) {
        onReady();
      }
    });
  }
})();
